export const selectSchool = ({ school }) => school;
